document.addEventListener('DOMContentLoaded', function () {
    const calcButton = document.getElementById('thcCalcButton');
    if (!calcButton) return;
    calcButton.addEventListener('click', calculateTHC);
  });

  function calculateTHC() {
    console.log('click.....')
    const freq = document.getElementById('frequency').value;
    const amount = parseFloat(document.getElementById('amount').value);
    const thcPercent = parseFloat(document.getElementById('thcPercent').value);
    const hoursSince = parseFloat(document.getElementById('hoursSince').value);
    const type = document.getElementById('type').value;
    const age = parseInt(document.getElementById('age').value);
    const bodyFat = parseFloat(document.getElementById('bodyFat').value);
    const hydration = document.getElementById('hydration').value;
    const metabolism = document.getElementById('metabolism').value;
    const cardio = document.getElementById('cardio').value;

    const THCmg = amount * 1000 * (thcPercent / 100);

    const F_freq = {'Yearly':1.0,'Unique':1.0,'Monthly':1.1,'Weekly':1.3,'Once a week':1.3,'Several times a week':1.6,'Daily':2.2}[freq] || 1.0;
    const F_type = type === 'edible' ? 1.3 : 1.0;
    const F_met = metabolism === 'fast' ? 0.9 : metabolism === 'slow' ? 1.15 : 1.0;
    let F_hyd = 1;if (hydration === "low") F_hyd = 1.05;
    if (hydration === "normal") F_hyd = 1;
    if (hydration === "high") F_hyd = 0.97;
    const F_card = cardio === "daily" ? .95  : cardio === "regular" ? .97  : cardio === "light" ? 1.03 : cardio === "none" ? 1.05 : 1;

    let F_age = 1.0;
    if (age <= 25) F_age = 0.95;
    else if (age <= 40) F_age = 1.0;
    else if (age <= 60) F_age = 1.08;
    else F_age = 1.15;

    let F_body = 1.0;
    if (!isNaN(bodyFat)) {
      if (bodyFat <= 15) F_body = 0.97;
      else if (bodyFat <= 25) F_body = 1.0;
      else if (bodyFat <= 35) F_body = 1.05;
      else F_body = 1.12;
    }

    const F_total = F_freq * F_type * F_met * F_hyd * F_card * F_age * F_body;
    const baseMin = type === 'edible' ? 12 : 6;
    const baseMax = type === 'edible' ? 36 : 24;

    let estMin = Math.min(baseMin * F_total, 168);
    let estMax = Math.min(baseMax * F_total, 168);

    const remMin = Math.max(0, estMin - hoursSince);
    const remMax = Math.max(0, estMax - hoursSince);

let status = THC_TRANSLATIONS.lower;
if (remMax > 24) status = THC_TRANSLATIONS.high;
else if (remMax > 6) status = THC_TRANSLATIONS.moderate;

    document.getElementById('results').style.display = 'none';
    // document.getElementById('thcIntake').innerText = `Estimated THC consumed: ${THCmg.toFixed(0)} mg`;
    // document.getElementById('timeWindow').innerText = `Estimated remaining time until blood THC is likely low: ${remMin.toFixed(0)} – ${remMax.toFixed(0)} hours`;
    // document.getElementById('riskStatus').innerText = status;
    document.querySelector('.omnisend_wrapper').style.display = 'block';
    document.querySelector('.omnisend_wrapper input[name="custom_thc_intake"]').value =
  `${THC_TRANSLATIONS.intake} ${THCmg.toFixed(0)} mg`;

document.querySelector('.omnisend_wrapper input[name="custom_timeWindow"]').value =
  `${THC_TRANSLATIONS.time} ${remMin.toFixed(0)} – ${remMax.toFixed(0)} hours`;
    console.log(`${THC_TRANSLATIONS.intake} ${THCmg.toFixed(0)} mg`)
    console.log(`${THC_TRANSLATIONS.time} ${remMin.toFixed(0)} – ${remMax.toFixed(0)} hours`) 
    document.querySelector('.omnisend_wrapper input[name="custom_riskStatus"]').value = status;
  }